import { IBaseModel } from "../../models/base.model";
import { IAcaoPlanoAcaoHistoricoModel } from "../../models/plano-acao-model";

export interface IAbasHistoricoAcao {
  historicos: IAcaoPlanoAcaoHistoricoModel[];
  numeroAbaAtiva: number;
  historicosAnteriores: IAcaoPlanoAcaoHistoricoModel[];
}

// Demanda 68742 linha 41: a aba ativa é o ciclo aberto (sem avaliação).
// Se todos os ciclos já foram avaliados, a aba corrente é o último ciclo persistido.
// Não se inventa uma aba N+1 — isso duplicava a única implementação na visualização.
export function calcularAbasHistorico(historicos: IAcaoPlanoAcaoHistoricoModel[]): IAbasHistoricoAcao {
  const lista = [...(historicos || [])].sort((a, b) => (a.numero ?? 0) - (b.numero ?? 0));
  const aberto = lista.filter(h => !h.dataMonitoramento).pop();
  const numeroAbaAtiva = aberto
    ? aberto.numero
    : (lista.length ? (lista[lista.length - 1].numero ?? lista.length) : 1);
  const historicosAnteriores = lista
    .filter(h => h.numero !== numeroAbaAtiva)
    .sort((a, b) => (b.numero ?? 0) - (a.numero ?? 0));
  // #region agent log
  fetch('http://127.0.0.1:7425/ingest/3db54933-b367-4436-8c45-2ac5d509e98a',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'6409f8'},body:JSON.stringify({sessionId:'6409f8',runId:'post-fix',hypothesisId:'E',location:'plano-acao-historico-abas.ts:calcularAbasHistorico',message:'abas calculadas',data:{numeros:lista.map(h=>h.numero),abertos:lista.filter(h=>!h.dataMonitoramento).map(h=>h.numero),numeroAbaAtiva,anteriores:historicosAnteriores.map(h=>h.numero)},timestamp:Date.now()})}).catch(()=>{});
  // #endregion
  return { historicos: lista, numeroAbaAtiva, historicosAnteriores };
}

export function cicloAvaliacaoMaisRecente(historicos: IAcaoPlanoAcaoHistoricoModel[]): IAcaoPlanoAcaoHistoricoModel | null {
  const avaliados = [...(historicos || [])].filter(h => !!h.dataMonitoramento);
  if (!avaliados.length) {
    return null;
  }
  avaliados.sort((a, b) => (b.numero ?? 0) - (a.numero ?? 0));
  return avaliados[0];
}

export async function sobreporAvaliacaoMaisRecente(
  acoes: any[],
  obterHistorico: (acaoId: number) => Promise<IBaseModel<IAcaoPlanoAcaoHistoricoModel[]>>
): Promise<void> {
  await Promise.all((acoes || []).map(async (acao) => {
    if (!acao?.id) {
      return;
    }
    try {
      const res = await obterHistorico(acao.id);
      const ciclo = cicloAvaliacaoMaisRecente(res && res.sucesso ? (res.dados || []) : []);
      const acaoTime = acao.dataMonitoramento ? new Date(acao.dataMonitoramento).getTime() : 0;
      const cicloTime = ciclo?.dataMonitoramento ? new Date(ciclo.dataMonitoramento).getTime() : 0;
      // #region agent log
      fetch('http://127.0.0.1:7425/ingest/3db54933-b367-4436-8c45-2ac5d509e98a',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'6409f8'},body:JSON.stringify({sessionId:'6409f8',runId:'post-fix',hypothesisId:'J',location:'plano-acao-historico-abas.ts:sobreporAvaliacaoMaisRecente',message:'escolha da avaliacao impressa',data:{acaoId:acao.id,acaoTime,cicloNumero:ciclo?.numero??null,cicloTime,substituiu:!!ciclo && !(acaoTime>cicloTime)},timestamp:Date.now()})}).catch(()=>{});
      // #endregion
      if (!ciclo || (acaoTime > cicloTime)) {
        return;
      }
      acao.status = ciclo.status || acao.status;
      acao.descricaoImplementacaoAuditor = ciclo.descricaoImplementacaoAuditor;
      acao.dataMonitoramento = ciclo.dataMonitoramento;
      acao.responsavelNomeMonitoramento = ciclo.responsavelNomeMonitoramento || acao.responsavelNomeMonitoramento;
      if (ciclo.descricaoImplementacao) {
        acao.descricaoImplementacao = ciclo.descricaoImplementacao;
      }
      if (ciclo.dataRealizacao) {
        acao.dataRealizacao = ciclo.dataRealizacao;
      }
      if (ciclo.evidencias?.length) {
        acao.evidencias = ciclo.evidencias.map(e => ({ id: e.evidenciaOrigemId || e.id, nome: e.nome, acaoId: acao.id }));
      }
      if (ciclo.evidenciasAuditor?.length) {
        acao.evidenciasAuditor = ciclo.evidenciasAuditor.map(e => ({ id: e.evidenciaOrigemId || e.id, nome: e.nome, acaoId: acao.id }));
      }
    } catch {
      // mantém os dados já carregados da ação ou do snapshot
    }
  }));
}

export async function carregarAbasHistorico(
  obterHistorico: (acaoId: number) => Promise<IBaseModel<IAcaoPlanoAcaoHistoricoModel[]>>,
  acaoId: number
): Promise<IAbasHistoricoAcao> {
  try {
    const res = await obterHistorico(acaoId);
    return calcularAbasHistorico(res && res.sucesso ? (res.dados || []) : []);
  } catch {
    return calcularAbasHistorico([]);
  }
}
